module.exports = __webpack_public_path__ + "static/media/18.3527ce5c.jpg";